<template>
  <div class="btn-block" :class="{'btn-block--long': isSimpleProcess}">
    <!-- sellType售卖流程(1常规 2新一键购 3 微信投放 4 老一键购  5 常规一键购 ) -->
    <!-- 是否是已购的音视频商品 已购商品 引导去学习-->
    <template v-if="isBuyed && isAudition">
      <div class="layout-flex layout-flex_v--c layout-flex_block--1 left-content" style="flex-direction: row">

        <div v-if="this.shopping && !ptFlag" class="shopping_car_content" @click="goShoppingCar" style="margin-right: 0.1rem">
          <span v-if="shoppingCount" class="count">{{shoppingCount}}</span>
          <img src="../images/icon_car.png" srcset="../images/icon_car.png 1x, ../images/icon_car@2x.png 2x, ../images/icon_car@3x.png 3x" >
        </div>

        <div class="goods-pre layout-flex_block--1" >
          <div class="goods-pre-btn" style="max-width: 100%;margin: 0;" @click="leftClick(2)">去学习</div>
        </div>
      </div>
    </template>
    <!-- 拼团逻辑 begin-->
    <template v-else-if="ptFlag">
      <!-- <template v-if="userReallyOnline"> -->
        <!-- TODO 开启单报开关，由于需求后台单报开关隐藏，默认关闭，之后的拼团逻辑不会走这里 -->
        <div class="group_buy_btn" v-if="danbaoSwitch">
          <button class="left_btn" @click="rightClick">
            <div class="sale-price">
              <span v-if="!goodsDetail.couponUse && firstSelectSkuDiscountPrice">券后</span>
              <span class="icon">￥</span>
              <span class="price">{{ realPrice[0] }}</span>
              <span class="price small">.{{ realPrice[1] }}</span>
              <div
                class="priceRemark"
                v-if="goodsDetail.reduceFlag&&userReallyOnline"
              >{{ goodsDetail.reduceActivityName }}
              </div>
            </div>
            <div class="buy_text">{{ btnText }}</div>
          </button>
          <button class="right_btn" @click="rightClick({group_buy: true})">
            <div class="sale-price" :style="!dataHasPtAuth?{opacity: '0.4'}:{}">
              <span class="icon">￥</span>
              <span class="price">{{ ptPrice[0] }}</span>
              <span class="price small">.{{ ptPrice[1] }}</span>
            </div>
            <div class="buy_text" :style="!dataHasPtAuth?{opacity: '0.4'}:{}">{{ptRbtnText}}</div>
          </button>
        </div>
        <!-- 所以这里会展示，即展示一个宽度100%的按钮，btn_status为是否开启动效 -->
        <div v-else
          class="btn-block__btn btn-block__btn--long"
          :class="{
            'btn-block__btn--disabled': !dataHasPtAuth,
            'btn_status': btnStatus
          }"
          @click="rightClick({group_buy: true})">
            ￥{{ptPrice[0]}}.{{ptPrice[1]}} <span style="padding-left: 10px;">发起拼团</span>
        </div>
      <!-- </template>-->
    </template>
    <!-- 拼团逻辑 over-->
    <!-- 0元领取简化流程 begin-->
    <template v-else-if="isSimpleProcess">
      <div
        class="btn-block__btn btn-block__btn--long"
        :class="{
          'btn-block__btn--disabled': !goodsDetail.productStatus,
        }"
        @click="rightClick">{{line2Text}} </div>
    </template>
    <!-- 0元领取简化流程 over-->

    <!-- 是否是会员 start -->
    <!-- isGoodsBoughtVip  判断当前商品是否是会员权益商品  1 是 0否 -->
    <template v-else-if="goodsDetail.goodsType == 5 && openVipInfo.isGoodsBoughtVip && userReallyOnline && goodsDetail.productStatus">
      <!-- isUserVip  判断是否是会员  1 是 0否 -->
      <div class="vip-group-btn">
        <div class="vleft-btn" @click="rightClick()">
          <!-- <div v-if="goodsDetail.reduceActivityName && !goodsDetail.birdRemark" class="reduce_tag">{{goodsDetail.reduceActivityName}}</div> -->
          <!-- <div class="line1">优惠价：￥79</div>
          <div class="line2">优惠价：￥79</div> -->
          <!--
            小程序专属商品逻辑
            *  仅有早鸟价时：展示'早鸟价'即(birdRemark)。
            *  仅有优惠券时：展示到手价。
            *  有早鸟价+优惠券时：展示到手价
          -->
          <template>
            <div class="line1" v-if="showRightBtnLine1">
              <template>
                <span class="icon" v-if="couponText">{{couponText}}</span>
              </template>
              <template>
                <span class="text-price" v-if="goodsDetail.birdPrice"><span class="font15">{{ isApp ? '' : '￥' }}</span>{{goodsDetail.birdPrice}}</span>
                <template v-else>
                  <span class="text-price" style="margin: 0"><span class="font15">{{ isApp ? '' : '￥' }}</span>{{ realPrice[0]}}</span><span class="text-price" style="margin: 0">.{{ realPrice[1] }}</span>
                </template>
              </template>

              <span class="btn-text" v-if="isApp" style="color: #FF5F2E">少年贝</span>
            </div>
            <div class="line2" v-if="showRightBtnLine1" :style=" goodsDetail.birdPrice || goodsDetail.couponUse || firstSelectSkuDiscountPrice ? line2Style : ''">
              {{ goodsDetail.birdPrice || goodsDetail.couponUse || firstSelectSkuDiscountPrice ? line2Text : '立即购买' }}
            </div>

          </template>
          <!-- line2Style.textDecoration != 'line-through' 表示当前显示的是折线价，可以通过showLinePrice控制显示-->
          <div class="line2" v-if="showLinePrice() || line2Style.textDecoration != 'line-through'" :style="line2Style">
            {{line2Text}}
          </div>
        </div>
        <div class="vright-btn" v-if="openVipInfo.isUserVip" @click="exchange()">
          学习卡免费兑换
        </div>

        <div class="vright-btn2" v-else @click="exchange()">
          <div class="line1">开通学习卡</div>
          <div class="line2">免费兑换该课程</div>
        </div>
      </div>

      <!-- <div class="right-content" :style="(showLeftBtn || isPreSale) ? {width: '2.8rem'} : {width: '2rem'}"> -->
      <!-- <div v-else class="right-content" style="width: 100%; margin-left: 0;">
        <div class="right-group-btn" >
          <template>
            <div v-if="showLeftBtn"  class="right-btn left-btn" @click="rightClick()">

              <ExclusiveBtn
                :goodsDetail="goodsDetail"
                :showRightBtnLine1="showRightBtnLine1"
                :firstSelectSkuDiscountPrice="firstSelectSkuDiscountPrice"
                :firstSelectSkuVipCouponUse="firstSelectSkuVipCouponUse"
                :couponText="couponText"
                :realPrice="realPrice"
                :line2Style="line2Style"
                :line2Text="line2Text"
                />
            </div>
            <div  @click="exchange()"
              :class="`right-btn ${((goodsDetail.sellType === 5 || userReallyOnline) && btnHeatBeat && !showLeftBtn) ? 'heart-animate' : ''} ${goodsDetail.productStatus?'':'disabled'}`">
              <div class="line1">开通会员</div>
              <div class="line2">免费兑换该课程</div>
            </div>
          </template>
        </div>
      </div> -->

    </template>
    <!-- 是否是会员 end -->

    <template v-else>
      <div class="left-content">
        <template v-if="showLeftBtn || isPreSale">
          <div class="shopping_car_content" @click="goShoppingCar">
            <span v-if="shoppingCount" class="count">{{shoppingCount}}</span>
            <img src="../images/icon_car.png" srcset="../images/icon_car.png 1x, ../images/icon_car@2x.png 2x, ../images/icon_car@3x.png 3x" >
          </div>
        </template>
        <template v-else>
          <div class="goods-price-wrap" :style="goodsDetail.sellType === 1 ? {flexDirection: 'column', alignItems: 'flex-start'} : {}">
            <div class="sale-price" v-show="goodsDetail.showActualPrice">
              <span class="icon">￥</span>
              <span class="price">{{ setPrice( goodsDetail.goodsType == 7 ? packGoodsPrice : goodsDetail.showActualPrice, 0) }}</span>
              <span class="price small">.{{ setPrice( goodsDetail.goodsType == 7 ? packGoodsPrice : goodsDetail.showActualPrice, 1) }}</span>
            </div>
            <!-- 课包类型课程需要展示划线价 -->
            <div class="actual-price" v-if="(showLinePrice() && itemid !== '1285540373889687553' && itemid !== '1352529062860009474') || goodsDetail.goodsType == 7">
              <span class="icon">￥</span>
              <span class="price">{{ goodsDetail.goodsType == 7 ? packShowLinePrice : goodsDetail.showOriginalPrice }}</span>
            </div>
          </div>
          <div v-if="goodsDetail.sellType !== 1" class="good-desc">{{ goodsDetail.priceRemark }}</div>
        </template>
      </div>
      <div class="right-content" :style="(showLeftBtn || isPreSale) ? {width: '2.8rem'} : {width: '2rem'}">
        <!-- 预售商品 -->
        <div v-if="isPreSale" class="goods-pre layout-flex layout-flex_v--c layout-flex_h--sb">
          <div class="goods-pre-info">
            <div v-if="goodsDetail.reduceActivityName" class="goods-pre-reduce">{{goodsDetail.reduceActivityName}}</div>
            <div class="goods-pre-price">￥{{realPrice[0]}}.{{realPrice[1]}}</div>
            <span class="goods-pre-desc" v-if="preSaveData.goodsDescr">{{preSaveData.goodsDescr}}</span>
          </div>
          <div v-if="shopping" class="goods-pre-btn" @click="leftClick()">加入购物车</div>
          <div v-else class="goods-pre-btn goods-pre-btn--disabled" @click="leftClick(-1)">即将开售</div>
        </div>

        <!-- 非预售商品 -->
        <div v-else class="right-group-btn" >
          <template>
            <div v-if="showLeftBtn" class="left-btn" @click="leftClick()">
              加入购物车
            </div>
            <div :style="showLeftBtn ? {} : ( goodsDetail.birdRemark ? {borderRadius: '.24rem', flex: 1.5} : {borderRadius: '.24rem'})" @click="rightClick()"
              :class="`right-btn ${((goodsDetail.sellType === 5 || userReallyOnline) && btnHeatBeat && !showLeftBtn) ? 'heart-animate' : ''} ${goodsDetail.productStatus?'':'disabled'}`">
              <!-- <div v-if="goodsDetail.reduceActivityName && !goodsDetail.birdRemark" class="reduce_tag">{{goodsDetail.reduceActivityName}}</div> -->
              <!--
                小程序专属商品逻辑
                *  仅有早鸟价时：展示'早鸟价'即(birdRemark)。
                *  仅有优惠券时：展示到手价。
                *  有早鸟价+优惠券时：展示到手价
              -->
              <template v-if="goodsDetail.goodsType == 5">
                <ExclusiveBtn
                  :goodsDetail="goodsDetail"
                  :showRightBtnLine1="showRightBtnLine1"
                  :firstSelectSkuDiscountPrice="firstSelectSkuDiscountPrice"
                  :firstSelectSkuVipCouponUse="firstSelectSkuVipCouponUse"
                  :couponText="couponText"
                  :realPrice="realPrice"
                  :line2Style="line2Style"
                  :line2Text="line2Text"
                  />

              </template>

              <!-- 普通商品逻辑 -->
              <template v-else>
                <div class="line1" v-if="showRightBtnLine1">
                  <span class="icon" v-if="couponText">{{couponText}}</span>
                  <span class="price">￥{{ realPrice[0] }}</span><span class="price small">.{{ realPrice[1] }}</span>
                </div>

                <!-- <div class="line1" v-else style="opacity: 0.6">
                  {{line2Text}}
                </div> -->

              </template>

              <!-- line2Style.textDecoration != 'line-through' 表示当前显示的是折线价，可以通过showLinePrice控制显示-->
              <div class="line2" v-if="showLinePrice() || line2Style.textDecoration != 'line-through'" :style="line2Style">
                {{line2Text}}
              </div>
            </div>
          </template>

        </div>

      </div>
    </template>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { env } from '@utils';
import ExclusiveBtn from './exclusiveBtn.vue';

export default {
  // 是否显示划线价格0: 否， 1: 是
  inject: ['showLinePrice'],
  data() {
    let { activityId } = this.$route.query;
    return {
      single: false,
      activityId,
      isApp: false,
      isPackCrash: false,    // 课包权益 是否冲突 （仅仅校验第一层规格）
      // 按钮动效计时器
      timer: null,
    };
  },
  props: {
    ptFlag: String,
    firstSelectSkuDiscountPrice: Number,
    realPrice: {
      type: Array,
      default() {
        return [];
      }
    },
    ptPrice: {
      type: Array,
      default() {
        return [];
      }
    },
    btnText: String,
    ptRbtnText: String,
    initGroupBuyMark: Boolean,
    hasPtAuth: Boolean,
    dataHasPtAuth: Boolean,
    userReallyOnline: Boolean,
    goodsDetail: {
      type: Object,
      default() {
        return {};
      }
    },
    itemid: String,
    shopping: {
      type: Number,
      default: 0
    },
    shoppingCount: Number,
    isNoParamsCourse: Boolean,
    // 拼团是否关闭单独购买按钮，0 ｜ 1
    danbaoSwitch: {
      type: Number,
      default: 1
    },
    // 按钮动效开关
    btnStatus: {
      type: Number,
      default: 0
    },
    // 是否有会员券
    firstSelectSkuVipCouponUse: Number,
    couponUseType: Number,
    openVipInfo: {
      type: Object,
      default() {
        return {};
      }
    }

  },
  computed: {
    ...mapState('course', ['preSaveData']),
    line2Style() {
      let obj = {};
      const goods = this.goodsDetail;
      if (this.shopping && goods.productStatus) {
        obj.textDecoration = 'line-through';
      }
      if ((!this.goodsDetail.couponUse && !this.shopping && !this.goodsDetail.reduceFlag) || !goods.productStatus) {
        obj.fontSize = '0.16rem';
      }
      return obj;
    },

    /**
     * 商品类型 goodsType 1单品 2联报 4购物车商品 5专属商品
     */
    couponText() {
      let text = '';
      // 1-到手价 2-早鸟价 3-优惠价 4-券后价 5-立减价
      if (this.couponUseType == 1) {
        text = '到手价';
      } else if (this.couponUseType == 2) {
        text = this.goodsDetail.birdRemark;
      } else if (this.couponUseType == 3) {
        text = '优惠价';
      } else if (this.couponUseType == 4) {
        text = '券后价';
      } else if (this.couponUseType == 5) {
        text = this.goodsDetail.reduceActivityName;
      }
      return text;
    },
    line2Text() {
      const goods = this.goodsDetail;
      let text = '';
      if (goods.productStatus) {
        if (this.shopping) {
          text = `原价￥${goods.showOriginalPrice}`;
        } else {
          if (goods.couponUse && !this.activityId) {
            text = `${goods.ifReceived ? '用券' : '领券'}购买`;
          } else {
            text = goods.btnText || '立即购买';
          }

          // 如果是0元简化流程， 默认 0元领取
          if (this.isSimpleProcess) {
            text = goods.btnText || '0元领取';
          }
        }
      } else {
        text = goods.packStatus ? '课程已购' : '不在售卖期';
      }
      if (this.isNoParamsCourse) {
        const { specilMapping } = goods;
        if (specilMapping && !specilMapping[0].stockNum) {
          text = '已售罄';
        }
      }
      return text;
    },
    btnHeatBeat() {
      const goodsDetail = this.goodsDetail;
      return goodsDetail.btnStatus && !!goodsDetail.productStatus;
    },
    showLeftBtn() {
      return !!this.goodsDetail.productStatus && this.shopping;
    },
    showRightBtnLine1() {
      let show = false;
      const goods = this.goodsDetail;
      if ((goods.couponUse || goods.reduceFlag || this.shopping || this.firstSelectSkuDiscountPrice) && goods.productStatus) {

        show = true;
      }
      // if (this.isNoParamsCourse) {
      //   const { specilMapping } = goods;
      //   if (!specilMapping[0].stockNum) {
      //     show = false;
      //   }
      // }
      return show;
    },
    isPreSale() {
      return this.preSaveData && this.preSaveData.isPreSaleDuring;
    },
    // 是否已购买
    isBuyed() {
      return this.goodsDetail.boughtCount;
    },
    // 是否是试听
    isAudition() {
      return this.goodsDetail.whetherAudition;
    },
    // 是否是简化0元领取流程
    isSimpleProcess() {
      return this.goodsDetail.isSimplifyFlow && !this.ptFlag;
    },
    // 课包商品价格
    packGoodsPrice() {
      let price = this.goodsDetail.packageSkuInfos[0].actualPrice.toFixed(2) || '0.00';
      if (this.isPackCrash) {
        price = this.goodsDetail.showActualPrice;
      }
      return price;
    },
    // 课包商品划线价格
    packShowLinePrice() {
      // let price = this.goodsDetail.packageSkuInfos[0].originalPrice.toFixed(2) || '0.00';
      let price = parseFloat(this.goodsDetail.packageSkuInfos[0].originalPrice) || 0;
      const goodsIds = process.env.VUE_APP_ENVIRONMENT == 'PRODUCTION' ? ['1840282754314432513', '1840315341732462594'] : ['1840313263318032385'];
      if (this.isPackCrash && !goodsIds.includes(this.itemid)) {
        let packSkuInfo = this.goodsDetail.packageSkuInfos[0].packSkuInfo;
        let crashPrice = 0;
        packSkuInfo.forEach(it => {
          crashPrice = crashPrice + parseFloat(it.originalPrice);
        });
        price = crashPrice;
      }
      return price.toFixed(2);
    }
  },
  components: {
    ExclusiveBtn
  },
  created() {
    this.isApp = env.isApp;
    /**
     * 课包类型下判断第一层规格下面所有权益是否已购买，购买之后按钮取药置灰
     * packStatus  课包默认状态  1 - 权益冲突 且 商品属于正常 可售范围
     **/
    if (this.goodsDetail.goodsType == 7 && this.goodsDetail.packageSkuInfos.length) {
      let packInfo = this.goodsDetail.packageSkuInfos[0].packSkuInfo;
      let statusArr = packInfo.map(it => it.purchased.toString());
      // 是否存在未购买的课程
      if (!statusArr.includes('false')) {
        this.isPackCrash = true;
        if (this.goodsDetail.productStatus) {
          this.goodsDetail.packStatus = 1;
        }
        this.goodsDetail.productStatus = 0;
      }
    }

  },
  mounted() {
    const btns = document.querySelectorAll('.btn_status');
    btns.forEach(item => {
      if (this.timer) { clearInterval(this.timer) }
      this.timer = setInterval(() => {
        if (item.style.transform === 'scale(1.1)') {
          item.style.transform = 'scale(1.0)';
        } else {
          item.style.transform = 'scale(1.1)';
        }
      }, 300);
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    setPrice(price, index) {
      price = '' + price;
      return price.split('.')[index];
    },
    leftClick(status) {
      // -1: 即将开售 2: 去学习（已购）
      this.$emit('leftClick', status);
    },
    rightClick(data) {
      this.$emit('rightClick', data);
    },
    toLogin() {
      this.$emit('toLogin');
    },
    goShoppingCar() {
      this.$emit('goShoppingCar');
    },
    exchange() {
      this.$emit('exchangeVip');
    }
  }
};
</script>

<style lang='stylus' scoped>
*
  box-sizing border-box
.btn-block
  position fixed
  display flex
  justify-content space-between
  align-items center
  bottom 0
  left 0
  width 100%
  height calc(80px + env(safe-area-inset-bottom))
  padding 0 20px
  background-color white
  box-shadow 0px 0px 10px 0px rgba(0, 0, 0, 0.08)
  padding-bottom constant(safe-area-inset-bottom)
  padding-bottom env(safe-area-inset-bottom)
  z-index 9;
  &.btn-block--long {
    height calc(60px + env(safe-area-inset-bottom));
    justify-content center;
  }
  .group_buy_btn
    display flex
    button
      font-size 15px
      color #fff
      min-width 168px
      height 46px
    .left_btn
      color #FF5F2E
      background-color #FFEAE0
      border-bottom-left-radius 20px
      border-top-left-radius 20px
      border none
      .priceRemark
        background-color #FF5440
        padding 8px 10px
        position absolute
        top -15px
        font-size 11px
        color #FFE9C2
        border-radius 8px
        &:after
          position absolute
          left 10px
          bottom -8px
          display block
          content ''
          width 0
          height 0
          border 4px solid rgba(0, 0, 0, 0)
          border-top-color #FF5440
      .sale-price
        display flex
        align-items baseline
        justify-content center
        color #FF5F2E
        span.icon
          font-size 16px
          font-weight 700
          line-height 14px
        span.price
          line-height 20px
          font-size 16px
          font-family Oswald-Medium
          &.small
            line-height 14px
            font-size 10px
      .buy_text
        font-size .12rem
    .right_btn
      background-color #FF5F2E
      border-bottom-right-radius 20px
      border-top-right-radius 20px
      border none
      .sale-price
        display flex
        align-items baseline
        justify-content center
        span.icon
          font-size 16px
          font-weight 700
          line-height 14px
        span.price
          line-height 20px
          font-size 16px
          font-family Oswald-Medium
          &.small
            line-height 14px
            font-size 10px
      .buy_text
        font-size .12rem
  .goods-price-wrap
    display flex
    align-items center
    margin-bottom 2px
    &.extra-wrap
      align-items flex-start
    .sale-price
      display flex
      align-items flex-end
      color #FF5F2E
      span.icon
        font-size 14px
        font-weight 700
        line-height 14px
      span.price
        line-height 20px
        font-size 20px
        font-family Oswald-Medium
        &.small
          line-height 14px
          font-size 14px
    .actual-price
      display flex
      color #C2C2CC
      align-items center
      line-height 14px
      font-size 12px
      text-decoration line-through
    .reduce-price
      display flex
      align-items center
      color #41414D
      line-height 16px
      span.icon
        font-size 14px
        font-weight 700
      span.price
        font-family Oswald-Medium
        font-size 14px
      .tag
        margin-left 5px
        position relative
        background #FF5F2E
        color #FFFFCB
        font-size 10px
        font-weight 700
        line-height 14px
        padding 0 2px
        border-bottom-left-radius 4px
        border-top-right-radius 4px
        border-bottom-right-radius 4px
        &::before
          content ' '
          width 5px
          height 100%
          position absolute
          background-image url('../images/h5_label_laosheng1.png')
          background-size 5px 100%
          margin-left -6px
  button
    font-size 15px
    color #fff
    min-width 120px
    height 40px
    &.login-btn
      width 160px
      border-radius 20px
      background-color #FF9800
  .left-content
    display flex
    flex 1
    flex-direction column
    justify-content center
    .shopping_car_content
      position relative
      .count
        position absolute
        display flex
        justify-content center
        align-items center
        left 18px
        top -2px
        width 22px
        height 22px
        font-size 16px
        color #FF5F2E
        transform scale(0.5)
        border 2px solid #FF5F2E
        border-radius 50%
      img
        width 33px
    .goods-price-wrap
      display flex
      align-items flex-end
      margin-bottom 2px
      .sale-price
        display flex
        align-items flex-end
        color #FF5F2E
        span.icon
          font-size 14px
          font-weight 700
          line-height 14px
        span.price
          line-height 20px
          font-size 20px
          font-family Oswald-Medium
          &.small
            line-height 14px
            font-size 14px
      .actual-price
        display flex
        color #C2C2CC
        align-items center
        line-height 14px
        font-size 12px
        text-decoration line-through
    .good-desc
      display flex
      align-items center
      font-size 12px
      color #A1A1B3
      line-height 17px
  .right-content
    margin-left 20px
    align-self center
    .right-group-btn
      display flex
      width 100%
      height 48px
      font-size 16px
      color white
      .left-btn
        display flex
        flex 1
        height 100%
        align-items center
        justify-content center
        border-radius 24px 0 0 24px !important
        background-color #FBAC00 !important
      .right-btn,.vip-leftbtn
        position relative
        display flex
        flex 1.5
        flex-direction column
        height 100%
        align-items center
        justify-content center
        border-radius 0 24px 24px 0
        background-color #FF5F2E
        text-align center
        .reduce_tag
          position absolute
          width 76px
          height 18px
          line-height 18px
          text-align center
          top -18px
          font-size 12px
          color #FF5F2E
          font-weight bold
          border-radius 10px
          background-color white
          &:after
            position absolute
            left 34px
            bottom -8px
            display block
            content ''
            width 0
            height 0
            border 4px solid rgba(0, 0, 0, 0)
            border-top-color white
        .line1
          margin-bottom 2px
          span.price
            font-size 20px
            font-family Oswald-Medium
            &.small
              line-height 14px
              font-size 14px
          .btn-text
            font-size 15px
            color #fff
          .text-price
            font-size 17px
            margin 0 2px
            font-weight normal
          .font15
            font-size 15px
        .line2
          font-size 12px
.heart-animate
  animation heatBeat 1s infinite
@keyframes heatBeat
  0%
    transform scale(.85)
  50%
    transform scale(1.05)
  100%
    transform scale(.85)
.disabled
  color rgb(255, 255, 255)
  background-color rgb(212, 212, 217)!important

// 预售样式
.goods-pre {
  .goods-pre-info {
    position: relative;
    margin-left: -10px;
    .goods-pre-reduce {
      position: absolute;
      top: -33px;
      height: 24px;
      padding: 0 11px;
      line-height: 24px;
      text-align: center;
      font-size: 12px;
      color: #fff;
      font-weight: bold;
      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 26px;
      white-space:nowrap;
      &:after{
        position: absolute;
        left: 50%;
        bottom: -0.11rem;
        content: '';
        width: 0;
        height: 0;
        margin-left: -0.06rem;
        border: 0.06rem solid rgba(0,0,0,0);
        border-top-color: rgba(0,0,0,0.5);
      }
    }
  }
  .goods-pre-price {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FF5F2E;
    line-height: 20px;
  }
  .goods-pre-desc {
    display: inline-block;
    margin-top: 5px;
    padding: 2px 4px;
    font-size: 10px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FF5F2E;
    border-radius: 3px;
    border: 1px solid #FF5F2E;
  }
  .goods-pre-btn {
    flex: 1
    max-width: 152px;
    height: 48px;
    margin-left: 10px;
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 48px;
    background: #FF5F2E;
    border-radius: 24px;
    &.goods-pre-btn--disabled{
      opacity: 0.31;
    }
  }
}

.btn-block__btn {
  flex: 1
  &.btn-block__btn--long {
    width: 315px;
    height: 46px;
    line-height: 46px;
    margin: 0 auto;
    text-align: center;
    background: url('https://coolcdn.igetcool.com/p/2023/3/68cada40c1065d8e86cddffa3a68de21.png?_630x92.png') no-repeat center center;
    background-size: 100% 100%;
    background-position: center center;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
  }
  &.btn-block__btn--disabled{
    opacity: 0.31;
  }
  &.btn_status {
    // animation: heatBeat .5s linear;
    // animation-iteration-count: infinite;
    display: flex;

    align-items: center;
    justify-content: center;
    background: url('https://coolcdn.igetcool.com/p/2023/12/b4fc702fc81fe4329de63f6272d78c39.png?_1125x264.png') no-repeat;
    background-position: center;
    background-size: 100%;
    height: 100%;
  }
}
// @keyframes heatBeat {
//   0% {
//   }
//   100% {
//   }
// }
.vip-leftbtn
  border-radius 24px 0 0 24px !important
  background-color #FBAC00 !important
.vip-group-btn
  width 100%
  display flex;
  justify-content space-between;
.vleft-btn
  width: 160px;
  height: 48px;
  border-radius: 24px;
  border: 1px solid #FF5F2E;
  box-sizing: border-box;
  text-align: center;
  color: #FF5F2E;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  position relative
  .reduce_tag
    position absolute
    width 76px
    height 18px
    line-height 18px
    text-align center
    top -20px
    font-size 12px
    color #FF5F2E
    font-weight bold
    border-radius 10px
    background-color white
    &:after
      position absolute
      left 34px
      bottom -8px
      display block
      content ''
      width 0
      height 0
      border 4px solid rgba(0, 0, 0, 0)
      border-top-color white
  .line1
    margin-bottom 2px
    .icon
      font-size 12px
      font-weight 500
    span.price
      font-size 20px
      font-family Oswald-Medium
      &.small
        line-height 14px
        font-size 14px
    .btn-text
      font-size 12px
      font-weight 500
      color #fff
    .text-price
      font-size 15px
      margin 0 2px
      font-weight 500
    .font15
      font-size 15px
  .line2
    font-size 12px

.vright-btn
  width 160px;
  height 48px;
  text-align center;
  line-height 48px;
  background #FF5F2E;
  font-size 16px;
  color #FFFFFF;
  border-radius: 24px;
.vright-btn2
  width 160px;
  height 48px;
  background #FF5F2E;
  color #FFFFFF;
  border-radius: 24px;
  position relative
  display flex
  flex-direction column
  align-items center
  justify-content center
  .line1
    margin-bottom 2px
  .line2
    font-size 12px
</style>